import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=18817110&scoped=true"
import script from "./clientDetail.vue?vue&type=script&lang=js"
export * from "./clientDetail.vue?vue&type=script&lang=js"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=18817110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18817110",
  null
  
)

export default component.exports